module.exports = __webpack_public_path__ + "static/media/Snehasish_Bose.ff9c85b2.jpg";